<template>
  <div>
    <select-date-header></select-date-header>
    <select-date-title-lea-abs-etc
      :activeTab="activeTab"
    ></select-date-title-lea-abs-etc>
    <select-date-content-appl
      @selectDate="selectDate"
      ref="selectDateContentAppl"
    ></select-date-content-appl>
  </div>
</template>
<script>
import SelectDateHeader from '@/components/application/form/SelectDateHeader.vue';
import SelectDateContentAppl from '@/components/application/form/SelectDateContentAppl.vue';
import SelectDateTitleLeaAbsEtc from '@/components/application/form/SelectDateTitleLeaAbsEtc.vue';

import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';

import { mapGetters } from 'vuex';
import applCode from '@/const/applCodeConstants';
import { getRemainDaysBefore, getReturnYmd } from '@/api/workStatus';

export default {
  mixins: [applCdMixin],
  components: {
    SelectDateHeader,
    SelectDateContentAppl,
    SelectDateTitleLeaAbsEtc,
  },
  data: () => ({
    activeTab: 'E',
    type: '',
    count: 0,
  }),
  computed: {
    ...mapGetters('ELA', ['GET_S_YMD', 'GET_E_YMD', 'GET_APPL_CD1']),
    ...mapGetters(['GET_APPL_CD', 'GET_RETURNYMD', 'GET_APPL_TYPE', 'GET_REF_SDATE', 'GET_REF_EDATE', 'GET_PER_DAY', 'GET_PARLEV_RETURN_YMD','GET_ADD_LIMIT_TERM']),
  },
  methods: {
    async selectDate(ymd) {

      if (
        this.GET_APPL_TYPE === 'parLeave' &&
        this.GET_E_YMD.replaceAll('-', '') >= ymd
      ) {
        alert('연장신청일이 복직예정일 보다 작거나 같은 수 없습니다');
        this.OFF_APP_SPINNER();
        if (this.count === 0) {
          this.$refs.selectDateContentAppl.dates =
            this.$refs.selectDateContentAppl.dates[0];
        } else {
          this.$refs.selectDateContentAppl.dates =
            this.$refs.selectDateContentAppl.dates[1];
        }

        this.count++;
        return;
      }

      let response;

      if (this.GET_APPL_CD === applCode.LeaAbsApplication) {
        let params = {};

        response = await getReturnYmd(params);

        if (ymd > response.data.data.returnYmd) {
          alert('복직신청일이 복직예정일 보다 클 수 없습니다');
          this.OFF_APP_SPINNER();
          if (this.count === 0) {
            this.$refs.selectDateContentAppl.dates =
              this.$refs.selectDateContentAppl.dates[0];
          } else {
            this.$refs.selectDateContentAppl.dates =
              this.$refs.selectDateContentAppl.dates[1];
          }

          this.count++;

          return;
        }
      }

      if (this.GET_APPL_CD === applCode.LeaAbsApplication) {
        this.$router.push(routerNames.LeaAbsAppRehView);
      } else if (this.GET_APPL_CD === applCode.LeaAbsExtension) {

        // 휴직기간 종료일에서 - 현재선택한 날짜를 빼면 사용가능일이 나옴
        let caDay = this.getDaysBetween(this.GET_REF_EDATE, ymd);

        let params = {
          sYmd: this.GET_REF_SDATE,
        }

      let response = await getRemainDaysBefore(params);

        if ((response.data.data.remainDaysBefore - this.GET_PER_DAY + 1 + this.GET_ADD_LIMIT_TERM) < caDay) {
          alert('신청가능일수를 초과 하였습니다');
          this.OFF_APP_SPINNER();
          return;
        }

        this.$router.push(routerNames.LeaAbsAppParLeaveView);
      } else {
        alert('준비중 입니다');
        this.OFF_APP_SPINNER();
      }
    },

    getDaysBetween(startDt, endDt) {
      if (startDt === "" || endDt === "") {
          return "";
      }

      let sDt = new Date(startDt.substring(0, 4), startDt.substring(4, 6) - 1, startDt.substring(6, 8));
      let eDt = new Date(endDt.substring(0, 4), endDt.substring(4, 6) - 1, endDt.substring(6, 8));

      return Math.floor(eDt.valueOf() / (24 * 60 * 60 * 1000) - sDt.valueOf() / (24 * 60 * 60 * 1000) + 1);

    },
  },
  async mounted() {
    if (this.GET_APPL_CD1 === '160') {
      this.$refs.selectDateContentAppl.dates = this.GET_PARLEV_RETURN_YMD;
    }
    this.$store.commit('SET_PARAMS', []);
    this.$store.commit('SET_FILE_SEQ', '');
  },
  destroyed() {
    this.OFF_APP_SPINNER(); // 스피너 OFF
  },
};
</script>
<style></style>
